import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import RetailerLink from "web/react/components/retailer-link/retailer-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./price-info.css";

export function PriceInfo({
    currentPriceHtml,
    // note: formattedPrice is the previous price if eg on sale. the "real" price is currentPrice
    formattedPrice,
    isInStock,
    isOnSale,
    leadUrl,
    saleCountLabel,
    retailerName,
    selectedShipping,
    retailAreaText,
}) {
    // If it's out of stock, it's not on sale
    if (!isInStock) {
        isOnSale = false;
    }

    let shippingCostLabel = "";
    let guaranteedFreeShipping = false;
    if (selectedShipping) {
        if (selectedShipping.is_free) {
            guaranteedFreeShipping = true;
            shippingCostLabel = gettext("general.free_shipping");
        } else {
            shippingCostLabel = gettext("in_stock_product.shipping_cost", {
                shipping_cost: selectedShipping.formatted_price,
            });
        }
    }

    return (
        <div className={styles.priceArea}>
            <span className={styles.bothPrices}>
                <span
                    className={classnames(styles.price, {
                        [styles.oos]: !isInStock,
                        [styles.reducedPrice]: isOnSale,
                    })}
                    dangerouslySetInnerHTML={{ __html: currentPriceHtml }}
                />
                {isOnSale && (
                    <span className={styles.originalPrice}>
                        {" "}
                        <del>{formattedPrice}</del>
                    </span>
                )}
            </span>
            {shippingCostLabel && (
                <span className={classnames(styles.shippingCost)}>
                    {guaranteedFreeShipping && (
                        <SVGIcon name="truck" className={styles.freeShippingIcon} />
                    )}
                    <span className={styles.shippingCostLabel}>{shippingCostLabel}</span>
                </span>
            )}
            <div className={styles.retailArea}>
                {retailAreaText ? (
                    <span dangerouslySetInnerHTML={{ __html: retailAreaText }} />
                ) : (
                    <RetailerLink
                        retailerName={retailerName}
                        leadUrl={leadUrl}
                        saleCountLabel={saleCountLabel}
                    />
                )}
            </div>
        </div>
    );
}

PriceInfo.propTypes = {
    currentPriceHtml: PropTypes.string.isRequired,
    formattedPrice: PropTypes.string.isRequired,
    isInStock: PropTypes.bool,
    isOnSale: PropTypes.bool.isRequired,
    leadUrl: PropTypes.string.isRequired,
    saleCountLabel: PropTypes.string,
    retailerName: PropTypes.string,
    selectedShipping: ShippingOptionPropType,
    retailAreaText: PropTypes.string,
};

PriceInfo.defaultProps = {
    isInStock: true,
    saleCountLabel: null,
};

export default PriceInfo;
